import React from 'react'

import { useParams } from 'utils/hooks'
import { useReport } from 'redux/hooks/Reports'
import { useTranslation } from 'language/translator'

import ReportTemplate from 'components_new/templates/ReportTemplate'
import SectionHeader from 'components_new/molecules/SectionHeader'

import ReportEditionsTable from 'components_new/organisms/ReportEditionsTable'

const ReportEditions = () => {
  const { id } = useParams<{ id: string }>()

  const report = useReport(id)
  const { t } = useTranslation()

  // loading
  if (!report) return <></>

  // success
  return (
    <>
      <ReportTemplate
        content={{ fullWidth: true }}
        subpage={{
          href: `/reports/${report.id}/editions`,
          icon: { name: 'Published' as const },
          title: t('global', 'editions')
        }}
        variant="static"
      >
        <SectionHeader
          gutterBottom={true}
          size="large"
          title={t('global', 'editions')}
        />
        <ReportEditionsTable editMode={true} reportId={id} />
      </ReportTemplate>
    </>
  )
}

export default ReportEditions
